import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class AkmPbiTask extends AbstractRequestTask {

    constructor(node = "", user_status = '') {
        super();
        this._node = node;
        this._user_status = user_status;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");

        return `${http}${url}/services/payway/akmpbi`;
    }

    getParams() {
        const params = super.getParams();
        const node = this._node;
        const user_status = this._user_status.user_status;
        const object_type = 'A'

        delete params.device_name;
        delete params.user_id;
        delete params.user_token;

        return Object.assign({}, params, { node, user_status, object_type });
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }
}

export default AkmPbiTask;





// WEBPACK FOOTER //
// ./src/requests/tasks/cms/AkmPbiTask.js